export default __webpack_public_path__ + "static/media/bg-red.f32c2d36.jpeg";